import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { uuid } from 'uuidv4';
import { Container, ContainerFields, ContainerFilterSelect } from './styles';
import Header from '../../components/Header';
import IAPICadReportsBi from './IAPICadReportsBi';
import api from '../../services/api';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { MdAspectRatio, MdFullscreenExit } from 'react-icons/md';

const idfieldSelectModulo = '83cf759ff4b3c15e5e557e21acd6c37a';
const idfieldSelectMenu = '31a6c76347dd4c7167b9c1c83f069003';
const idfieldSelectRelatorio = '35a6c76347dd4c7167b9c1c83f069077';

const DashboardPowerBI: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const [urlPowerBI, setUrlPowerBI] = useState<string>('');
  const [listCadReportsBi, setListCadReportsBi] = useState<IAPICadReportsBi[]>([]);
  const [listModulo, setListModulo] = useState<string[]>([]);
  const [listMenu, setListMenu] = useState<string[]>([]);
  const [listRelatorio, setListRelatorio] = useState<string[]>([]);
  const [showHeader, setShowHeader] = useState<boolean>(true);

  const licencaInvalida = useCallback((): boolean => {
    if (user && user.license.id === '') {
      addToast({
        type: 'error',
        title: 'Licença inválida',
        description: 'Usuário não está vinculado a nenhuma licença',
      });
      return true;
    }
    return false;
  }, [user, addToast]);

  const getCadReportsBi = useCallback(async () => {
    const response = await api.post<IAPICadReportsBi[]>(`/cadreportsbi/filter`, {
      license: user.license.id,
      id_usuario: user.id,
      id_company: user.empresa.id,
    });

    const tmpModulo: string[] = [''];
    const tempList: IAPICadReportsBi[] = response.data.map(iemList => {
      if (!tmpModulo.includes(iemList.desc_modulo?.trim())) {
        tmpModulo.push(iemList.desc_modulo?.trim());
      }
      return {
        ...iemList,
        access_key: iemList.access_key || uuid(),
        company: `${iemList.code}-${iemList.name}[${iemList.cnpj}]`,
      };
    });

    setListCadReportsBi(tempList);
    setListModulo(tmpModulo);
  }, [user]);

  useEffect(() => {
    if (user && user.license && user.empresa) {
      if (licencaInvalida()) return;
      setUrlPowerBI('');
      getCadReportsBi();
    }
  }, [user, licencaInvalida, getCadReportsBi]);

  useEffect(() => {
    const handleFullScreenChange = () => {
      const isCurrentlyFullScreen =
      !!document.fullscreenElement ||
      !!(document as any).webkitFullscreenElement ||
      !!(document as any).msFullscreenElement;
      setShowHeader(!isCurrentlyFullScreen);
    };

    document.addEventListener('fullscreenchange', handleFullScreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullScreenChange); // Safari
    document.addEventListener('msfullscreenchange', handleFullScreenChange); // IE11

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullScreenChange);
      document.removeEventListener('msfullscreenchange', handleFullScreenChange);
    };
  }, []);

  const onChangeSelectModulo = useCallback(
    async (event: React.ChangeEvent<{ value: string }>) => {
      const localValue = event.target.value as string;
      const tmpMenu: string[] = [''];
      const tmpRelatorio: string[] = [''];
      listCadReportsBi
        .filter(itemList => itemList.desc_modulo?.trim() === localValue)
        .map(itemList => {
          if (!tmpMenu.includes(itemList.desc_menu?.trim())) {
            tmpMenu.push(itemList.desc_menu?.trim());
          }
          if (!tmpRelatorio.includes(itemList.desc_relatorio?.trim())) {
            tmpRelatorio.push(itemList.desc_relatorio?.trim());
          }
          return itemList;
        });
      setListMenu(tmpMenu);
      setListRelatorio(tmpRelatorio);
      setUrlPowerBI('');
    },
    [listCadReportsBi],
  );

  const onChangeSelectMenu = useCallback(
    async (event: React.ChangeEvent<{ value: string }>) => {
      const localValue = event.target.value as string;
      let localModulo = '';
      const tmpRelatorio: string[] = [''];
      const fieldSelectModulo = document.getElementById(idfieldSelectModulo);
      if (fieldSelectModulo) {
        localModulo = (fieldSelectModulo as HTMLSelectElement).value;
      }
      listCadReportsBi
        .filter(itemList => itemList.desc_modulo?.trim() === localModulo && itemList.desc_menu?.trim() === localValue)
        .map(itemList => {
          if (!tmpRelatorio.includes(itemList.desc_relatorio?.trim())) {
            tmpRelatorio.push(itemList.desc_relatorio?.trim());
          }
          return itemList;
        });
      setListRelatorio(tmpRelatorio);
      setUrlPowerBI('');
    },
    [listCadReportsBi],
  );

  const onChangeSelectFilter = useCallback(
    async (event: React.ChangeEvent<{ value: unknown; id: string }>) => {
      let localModulo = '';
      let localMenu = '';
      let localRelatorio = '';
      const fieldSelectModulo = document.getElementById(idfieldSelectModulo);
      if (fieldSelectModulo) {
        localModulo = (fieldSelectModulo as HTMLSelectElement).value;
      }

      const fieldSelectMenu = document.getElementById(idfieldSelectMenu);
      if (fieldSelectMenu) {
        localMenu = (fieldSelectMenu as HTMLSelectElement).value;
      }

      const fieldSelectRelatorio = document.getElementById(idfieldSelectRelatorio);
      if (fieldSelectRelatorio) {
        localRelatorio = (fieldSelectRelatorio as HTMLSelectElement).value;
      }

      if (
        !['', null, undefined].includes(localModulo) &&
        !['', null, undefined].includes(localMenu) &&
        !['', null, undefined].includes(localRelatorio)
      ) {
        const findItem = listCadReportsBi.find(
          itemList =>
            itemList.desc_modulo?.trim() === localModulo &&
            itemList.desc_menu?.trim() === localMenu &&
            itemList.desc_relatorio?.trim() === localRelatorio,
        );
        if (findItem && !['', null, undefined].includes(findItem.url_power_bi?.trim())) {
          const urlExtra = '&navContentPaneEnabled=false&filterPaneEnabled=true'
          const localReportSectionPowerBi = findItem.report_section_power_bi
            ? `&pageName=ReportSection${findItem.report_section_power_bi.replace('ReportSection', '')}${urlExtra}`
            : '';
          const localLink = `${findItem.url_power_bi}${localReportSectionPowerBi}`;
          setUrlPowerBI(localLink);
        } else {
          setUrlPowerBI('');
        }
      } else {
        setUrlPowerBI('');
      }
    },
    [listCadReportsBi],
  );

  const onClickExpand = (inValue: boolean) => {
    setShowHeader(inValue);
    const elem = document.documentElement; // Pega o elemento raiz (html)

    if (!inValue) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if ((elem as any).webkitRequestFullscreen) {
        // Safari
        (elem as any).webkitRequestFullscreen();
      } else if ((elem as any).msRequestFullscreen) {
        // IE11
        (elem as any).msRequestFullscreen();
      }
    } else {
      const isCurrentlyFullScreen =
        document.fullscreenElement !== null ||
        (document as any).webkitFullscreenElement !== null || // Safari
        (document as any).msFullscreenElement !== null; // IE11

      if (isCurrentlyFullScreen) {
        if (document.exitFullscreen) {
          document?.exitFullscreen();
        } else if ((document as any).webkitExitFullscreen) {
          // Safari
          (document as any).webkitExitFullscreen();
        } else if ((document as any).msExitFullscreen) {
          // IE11
          (document as any).msExitFullscreen();
        }
      }
    }
  };

  return (
    <Container>
      {showHeader && <Header />}
      <div
        style={{
          display: 'grid',
          gap: '30px',
          gridTemplateColumns: '1fr 1fr 1fr',
          padding: '10px',
        }}
      >
        <div>
          <div
            style={{
              padding: '10px 0px 0px 0px',
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <div
              style={{
                width: '40px',
                marginRight: '10px',
                display: 'flex',
              }}
            >
              {showHeader ? (
                <Tooltip title="Tela cheia (F11)" placement="top">
                  <IconButton color="primary" aria-label="Tela Cheia" onClick={() => onClickExpand(!showHeader)}>
                    <MdAspectRatio size={40} color="#181818" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Sair da tela cheia (ESC)" placement="top">
                  <IconButton
                    color="primary"
                    aria-label="Sair da tela cheia"
                    onClick={() => onClickExpand(!showHeader)}
                  >
                    <MdFullscreenExit size={40} color="#181818" />
                  </IconButton>
                </Tooltip>
              )}
            </div>

            <div
              style={{
                width: '100%',
                display: 'flex',
                marginLeft: '10px',
                flexDirection: 'column',
              }}
            >
              <span>Módulo:</span>
              <ContainerFilterSelect>
                <select id={idfieldSelectModulo} onChange={onChangeSelectModulo}>
                  {listModulo.map(item => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </ContainerFilterSelect>
            </div>
          </div>
        </div>

        <div>
          <ContainerFields field="T100">
            <span>Menu:</span>
            <ContainerFilterSelect>
              <select id={idfieldSelectMenu} onChange={onChangeSelectMenu}>
                {listMenu.map(item => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </ContainerFilterSelect>
          </ContainerFields>
        </div>

        <div>
          <ContainerFields field="T100">
            <span>Relatório:</span>
            <ContainerFilterSelect>
              <select id={idfieldSelectRelatorio} onChange={onChangeSelectFilter}>
                {listRelatorio.map(item => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </ContainerFilterSelect>
          </ContainerFields>
        </div>
      </div>

      {urlPowerBI !== '' && (
        <iframe
          src={urlPowerBI}
          title="Analise"
          allowFullScreen
          style={{
            flex: 1,
            width: '100%',
            border: 'none',
          }}
        ></iframe>
      )}
    </Container>
  );
};

export default DashboardPowerBI;
